/* ExecutionLogRenderer.js */

"use strict";
const _ = require("lodash");
const Registrations = require("../../../../../../../RegistrationNamespaces");
const FileName = require("@gluenetworks/steve_utilities").fileName;

class ExecutionLogRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("logs-view-gl");
        this._rootElem.component = this._model;

        this._logDisplay = document.createElement("log-display-gl");
        this._rootElem.appendChild(this._logDisplay);
        this._logFile = "";
        this._logFileStarttime = undefined;
        this._onDownloadButtonClick = this._onDownloadButtonClick.bind(this);
        this._actionsRegistered = false;
        this._fileNamer = FileName;
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._logDisplay = undefined;
            resolve();
        });
        return prom;
    }

    _registerViewActions() {
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Back",
            name: "back",
            handler: this._onBackButtonClick.bind(this),
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Download",
            name: "cancel",
            handler: this._onDownloadButtonClick,
        });
    }

    _registerListeners() {
        this._model.on("LogsAdded", (this._onLogAdded = this._onLogAdded.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("LogAdded");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        this._model.whenModelIsReady().then(() => {
            this._setLogs(this._model.getLogs());
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onLogAdded(log) {
        this._setLogs(log);
        this._logDisplay.scrollTop = this._logDisplay.scrollHeight;
    }

    _onDownloadButtonClick() {
        if (!_.isEmpty(this._logFile)) {
            this._model._gameEditor.disableViewAction("cancel");
            const name = this._model._configExecutionEntity.pristineProperties.auditPolicy.name;
            let fileName = this._fileNamer({
                solution: "CDA",
                general: "PolicyExecLog",
                specific: name,
                date: this._logFileStarttime,
                suffix: "txt",
            });

            this.model.io.fileFactory.saveStringAsFile(this._logFile, fileName);
            this._model.gameEditor.enableViewAction("cancel");
        }
    }

    _onBackButtonClick() {
        this._model._gameEditor.setActiveView(Registrations.AUDIT_POLICY_EDITOR_VIEW_HISTORY, [
            {
                value: {
                    fqn: Registrations.AUDIT_POLICY_EDITOR_SUBVIEW_EXECUTION_LOG,
                },
            },
        ]);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setLogs(newVal) {
        this._logDisplay.innerHTML = "";
        if (!_.isUndefined(newVal)) {
            for (let i = 0; i < newVal.length; i++) {
                this._appendLog(newVal[i], i);
            }
        }
    }

    _appendLog(log, lln) {
        if (!this._actionsRegistered) {
            this._registerViewActions();
        }
        this._actionsRegistered = true;

        let logFileLine = [];
        let logEntry = document.createElement("p");

        // Line number
        let logLineNumber = document.createElement("span");
        logLineNumber.classList.add("log-line-number");
        logLineNumber.innerHTML = lln;
        logFileLine.push(lln);

        // Timestamp
        let timestamp = _.get(log, "time", undefined);
        let fileTimeStamp = timestamp;
        if (!_.isUndefined(timestamp)) {
            fileTimeStamp = Date.create(timestamp).format("{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{fff}");
            timestamp = Date.create(timestamp).format("{HH}:{mm}:{ss}.{fff}");
        } else {
            timestamp = "";
        }
        let time = document.createElement("span");
        time.classList.add("timestamp");
        time.innerHTML = timestamp;
        logFileLine.push(timestamp);
        if (!this._logFileStarttime) {
            this._logFileStarttime = fileTimeStamp;
        }

        // Message
        let message = document.createElement("span");
        message.classList.add("message");
        let msg = _.get(log, "msg", "");
        message.innerHTML = msg.replace(/</g, "&lt;");
        logFileLine.push(msg);

        logEntry.appendChild(logLineNumber);
        logEntry.appendChild(time);
        logEntry.appendChild(message);

        this._logDisplay.appendChild(logEntry);

        this._logFile += logFileLine.join(" ") + "\n";
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ExecutionLogRenderer;
